import { gql } from '@apollo/client';

export const SET_LAST_CONTACTED = gql`
  mutation setOfficerLastContacted($input: SetOfficerLastContactedInput!) {
    setOfficerLastContacted(input: $input) {
      clientMutationId
      errors
      deptAttribute {
        id
        lastContactedAt
        ori {
          id
          oriName
          abbreviation
        }
      }
    }
  }
`

// {
//   "input": {
//     "officerId": ID!,
//     "lastContactedAt": String,
//     "clientMutationId": String
//   }
// }
